<template>
  <div v-if="info">
    <van-popup v-model="show" round position="bottom" @click-overlay="close()" :close-on-click-overlay="false">
      <div class="popup-content">
        <template v-if="info.name">
          <div class="popup-title">机构认证</div>
          <div class="popup-ts">检测到您的IP地址在【{{ info.name }}】的授权范围内，可实现快捷认证。</div>
        </template>
        <div class="btns-group">
          <div class="btn-item btn-gray" @click="change()">选择机构</div>
          <template v-if="info.name">
            <div class="btn-item btn-blue" @click="trust()">快捷认证</div>
          </template>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  computed: {
    ...mapState({
      info: state => state.agency,
    })
  },
  data() {
    return {
      show: true,
    }
  },
  mounted() { },
  methods: {
    close() {
      this.$com.quick.agency.close();
    },
    change() {
      this.$com.quick.agency.close();
      this.$com.to.agency();
    },
    trust() {
      this.$api.QuickAgency({ schoolId: this.info.code }).then((res) => {
        if (res.code != 1) {
          return this.$com.message.error(res.info);
        }
        this.$com.member.reset(res.data).then(() => {
          this.$com.message.success("认证成功");
          location.href = location.href;
        });
      });
    }
  }
}
</script>

<style lang="stylus" scoped>
.popup-content
  padding('',2rem)
  .popup-title
    font-size 1.6rem
    font-weight bold
  .popup-ts
    color $blackColor_2
    font-size 1.2rem
    line-height: 1.6667;
    overflow-wrap: break-word;
    text-align: justify;
  .pp-checkbox
    margin('top',3rem)
    .checkedlink
      color $blue
  .btns-group
    MixinsFlex(nowrap,'justify','center')
    margin('top',1.5rem)
    gap 0 2rem
    .btn-item
      width 100%
      height 5rem
      line-height 5rem
      text-align center
      border('radius',.6rem)
      font-weight bold
      flex-shrink 1
      flex-grow 0
    .btn-gray
      background $grey_5
      color $blackColor_1
    .btn-blue
      background $blue
      color $bgWhite
</style>
<style>
  .van-checkbox__icon--checked .van-icon {
    color: #fff;
    background-color: #0d5899;
    border-color: #0d5899;
  }
</style>



// WEBPACK FOOTER //
// src/components/quick/QuickAgencyView.vue